import {
  RETRIEVE_CONVERSATIONS,
  RETRIEVE_CONVERSATION,
  SEND_MESSAGE,
  MARK_MESSAGE_READ,
  RETRIEVE_UNREAD_COUNT,
} from "../actions/types";

const initialState = {
  conversations: [],
  pagination: {},
  currentConversation: null,
  messages: [],
  messagePagination: {},
  unreadCount: 0,
};

const chatReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case RETRIEVE_CONVERSATIONS:
      return {
        ...state,
        conversations: payload?.conversations || [],
        pagination: payload?.pagination || {},
      };

    case RETRIEVE_CONVERSATION:
      return {
        ...state,
        currentConversation: payload,
        messages: payload?.messages || [],
        messagePagination: payload?.pagination || {},
      };

    case SEND_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, payload],
      };

    case MARK_MESSAGE_READ:
      return {
        ...state,
        messages: state.messages.map((msg) =>
          msg.id === payload.id ? { ...msg, status: payload.status } : msg
        ),
      };

    case RETRIEVE_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: payload?.unreadCount || 0,
      };

    default:
      return state;
  }
};

export default chatReducer;
